import { formatInTimeZone } from "date-fns-tz";

export const formatInTimezone = () => {
    return formatInTimeZone(
        Date.now(), 
        Intl.DateTimeFormat().resolvedOptions().timeZone, 
        "yyyy-MM-dd H:mm:ss"
    );
}